import { useState } from 'react';
import type { ViewId } from '@ox/schema';

export type AddedPreview = {
  viewId: ViewId;
  label: string;
  url: string;
};

export function AddedToCartModal({
  articleCount,
  previews,
  cartUrl,
  onContinue,
}: {
  articleCount: number;
  /** One entry per model view (mug = only Delante). */
  previews: AddedPreview[];
  cartUrl?: string;
  onContinue: () => void;
}) {
  const [loaded, setLoaded] = useState<Record<string, boolean>>({});

  if (previews.length === 0) return null;

  return (
    <div className="ox-modal-backdrop" onClick={onContinue}>
      <div className="ox-modal ox-added-modal" onClick={(e) => e.stopPropagation()}>
        <button type="button" className="ox-added-close" onClick={onContinue} aria-label="Cerrar">
          ✕
        </button>
        <div className="ox-added-check" aria-hidden>
          ✓
        </div>
        <h2 className="ox-added-title">
          Se han añadido {articleCount} artículo{articleCount === 1 ? '' : 's'} a tu cesta de la
          compra
        </h2>
        <div
          className={`ox-added-previews${previews.length === 1 ? ' ox-added-previews--single' : ''}`}
        >
          {previews.map((p) => (
            <div key={p.viewId} className="ox-added-thumb">
              {!loaded[p.viewId] && <div className="ox-added-skeleton" />}
              <img
                src={p.url}
                alt={p.label}
                onLoad={() => setLoaded((s) => ({ ...s, [p.viewId]: true }))}
                style={{ opacity: loaded[p.viewId] ? 1 : 0 }}
              />
              <span>{p.label}</span>
            </div>
          ))}
        </div>
        <div className="ox-added-actions">
          {cartUrl ? (
            <a className="ox-primary ox-added-primary" href={cartUrl}>
              Ir a la cesta
            </a>
          ) : (
            <button type="button" className="ox-primary ox-added-primary" onClick={onContinue}>
              Ir a la cesta
            </button>
          )}
          <button type="button" className="ox-added-secondary" onClick={onContinue}>
            Seguir creando
          </button>
        </div>
      </div>
    </div>
  );
}
